(function () {
  "use strict";

  // ---- Mobile nav ----
  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-f-nav-open]");
    var closer = e.target.closest("[data-f-nav-close]");
    var nav = document.querySelector("[data-f-mobile-nav]");
    if (opener && nav) nav.classList.add("is-open");
    if (closer && nav) nav.classList.remove("is-open");
  });

  // ---- Mega menu (hover-intent with a closing delay so the gap between the
  //      trigger and the dropdown doesn't cause it to vanish before you can
  //      reach it; also supports click/keyboard + outside-click to close) ----
  document.querySelectorAll("[data-f-mega]").forEach(function (mega) {
    var trigger = mega.querySelector(".f-mega__trigger");
    var closeTimer = null;

    function open() {
      clearTimeout(closeTimer);
      mega.classList.add("is-open");
      if (trigger) trigger.setAttribute("aria-expanded", "true");
    }
    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        mega.classList.remove("is-open");
        if (trigger) trigger.setAttribute("aria-expanded", "false");
      }, 350);
    }

    mega.addEventListener("mouseenter", open);
    mega.addEventListener("mouseleave", scheduleClose);

    if (trigger) {
      trigger.addEventListener("click", function (e) {
        e.preventDefault();
        if (mega.classList.contains("is-open")) {
          clearTimeout(closeTimer);
          mega.classList.remove("is-open");
          trigger.setAttribute("aria-expanded", "false");
        } else {
          open();
        }
      });
    }

    document.addEventListener("click", function (e) {
      if (!mega.contains(e.target)) {
        clearTimeout(closeTimer);
        mega.classList.remove("is-open");
        if (trigger) trigger.setAttribute("aria-expanded", "false");
      }
    });
  });

  // ---- Search overlay ----
  document.addEventListener("click", function (e) {
    var openBtn = e.target.closest("[data-f-search-open]");
    var closeBtn = e.target.closest("[data-f-search-close]");
    var overlay = document.querySelector("[data-f-search-overlay]");
    if (!overlay) return;
    if (openBtn) {
      overlay.classList.add("is-open");
      var input = overlay.querySelector("[data-f-search-input]");
      if (input) setTimeout(function () { input.focus(); }, 300);
    }
    if (closeBtn) {
      overlay.classList.remove("is-open");
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      var overlay = document.querySelector("[data-f-search-overlay]");
      if (overlay) overlay.classList.remove("is-open");
    }
  });

  // ---- Best sellers rail ----
  document.querySelectorAll("[data-f-rail]").forEach(function (rail) {
    var track = rail.querySelector("[data-f-rail-track]");
    var prev = rail.querySelector("[data-f-rail-prev]");
    var next = rail.querySelector("[data-f-rail-next]");
    if (!track) return;
    var scrollBy = function (dir) {
      var card = track.querySelector("[data-f-rail-item]");
      var amount = card ? card.getBoundingClientRect().width + 26 : 320;
      track.scrollBy({ left: dir * amount, behavior: "smooth" });
    };
    if (prev) prev.addEventListener("click", function () { scrollBy(-1); });
    if (next) next.addEventListener("click", function () { scrollBy(1); });
  });

  // ---- Collection filter pills (client-side, tag based) ----
  document.querySelectorAll("[data-f-filters]").forEach(function (bar) {
    var grid = document.querySelector(bar.getAttribute("data-f-filters"));
    if (!grid) return;
    var items = grid.querySelectorAll("[data-f-tags]");
    var countEl = document.querySelector("[data-f-filter-count]");
    bar.querySelectorAll("[data-f-filter]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        bar.querySelectorAll("[data-f-filter]").forEach(function (b) { b.classList.remove("is-active"); });
        btn.classList.add("is-active");
        var tag = btn.getAttribute("data-f-filter");
        var visible = 0;
        items.forEach(function (item) {
          var tags = (item.getAttribute("data-f-tags") || "").split("|");
          var show = tag === "*" || tags.indexOf(tag) !== -1;
          item.style.display = show ? "" : "none";
          if (show) visible++;
        });
        if (countEl) countEl.textContent = visible + (visible === 1 ? " piece" : " pieces") + " — sort by loved";
      });
    });
  });

  // ---- Product gallery: thumbnails, prev/next arrows, click-to-zoom lightbox ----
  document.querySelectorAll("[data-f-gallery]").forEach(function (gallery) {
    var main = gallery.querySelector("[data-f-gallery-main]");
    var thumbs = gallery.querySelectorAll("[data-f-thumb]");
    var images = JSON.parse(gallery.getAttribute("data-f-gallery-images") || "[]");
    var prevBtn = gallery.querySelector("[data-f-gallery-prev]");
    var nextBtn = gallery.querySelector("[data-f-gallery-next]");
    var lightbox = document.querySelector("[data-f-lightbox]");
    var lightboxImg = lightbox && lightbox.querySelector("[data-f-lightbox-img]");
    var lightboxCount = lightbox && lightbox.querySelector("[data-f-lightbox-count]");
    var lightboxPrev = lightbox && lightbox.querySelector("[data-f-lightbox-prev]");
    var lightboxNext = lightbox && lightbox.querySelector("[data-f-lightbox-next]");
    var lightboxClose = lightbox && lightbox.querySelector("[data-f-lightbox-close]");
    var index = 0;

    function setImage(i) {
      if (!images.length) return;
      index = ((i % images.length) + images.length) % images.length;
      var img = main && main.querySelector("img");
      if (img) img.src = images[index];
      thumbs.forEach(function (t, ti) { t.classList.toggle("is-active", ti === index); });
      if (lightbox && lightbox.classList.contains("is-open")) updateLightbox();
    }

    function updateLightbox() {
      if (!images.length || !lightboxImg) return;
      lightboxImg.src = images[index];
      if (lightboxCount) lightboxCount.textContent = (index + 1) + " / " + images.length;
    }

    function openLightbox() {
      if (!lightbox || !images.length) return;
      updateLightbox();
      lightbox.classList.add("is-open");
      lightbox.setAttribute("aria-hidden", "false");
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove("is-open");
      lightbox.setAttribute("aria-hidden", "true");
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener("click", function (e) {
        e.preventDefault();
        setImage(i);
      });
    });

    if (prevBtn) prevBtn.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); setImage(index - 1); });
    if (nextBtn) nextBtn.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); setImage(index + 1); });

    if (main) {
      main.addEventListener("click", function (e) {
        if (e.target.closest("[data-f-gallery-prev]") || e.target.closest("[data-f-gallery-next]")) return;
        openLightbox();
      });
    }

    if (lightboxClose) lightboxClose.addEventListener("click", closeLightbox);
    if (lightboxPrev) lightboxPrev.addEventListener("click", function () { setImage(index - 1); updateLightbox(); });
    if (lightboxNext) lightboxNext.addEventListener("click", function () { setImage(index + 1); updateLightbox(); });
    if (lightbox) {
      lightbox.addEventListener("click", function (e) {
        if (e.target === lightbox) closeLightbox();
      });
    }

    document.addEventListener("keydown", function (e) {
      if (!lightbox || !lightbox.classList.contains("is-open")) return;
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowLeft") { setImage(index - 1); updateLightbox(); }
      if (e.key === "ArrowRight") { setImage(index + 1); updateLightbox(); }
    });
  });

  // ---- Variant picker -> update hidden variant id + price ----
  document.querySelectorAll("[data-f-variant-picker]").forEach(function (root) {
    var form = root.closest("form");
    if (!form) return;
    var variantInput = form.querySelector("[name='id']");
    var priceEl = form.querySelector("[data-f-price]");
    var installEl = form.querySelector("[data-f-install]");
    var addBtn = form.querySelector("[data-f-add-btn]");
    var buyBtn = form.querySelector("[data-f-buy-btn]");
    var variants = JSON.parse(root.getAttribute("data-f-variants") || "[]");
    var selected = {};

    root.querySelectorAll("[data-f-option]").forEach(function (group) {
      var name = group.getAttribute("data-f-option");
      var active = group.querySelector(".is-active");
      if (active) selected[name] = active.getAttribute("data-f-value");
    });

    function syncButton(btn, available) {
      if (!btn) return;
      if (available) {
        btn.removeAttribute("disabled");
        btn.textContent = btn.getAttribute("data-f-label-available");
      } else {
        btn.setAttribute("disabled", "disabled");
        btn.textContent = "Sold Out";
      }
    }

    function applySelection() {
      var match = variants.find(function (v) {
        return Object.keys(selected).every(function (k) { return v.options[k] === selected[k]; });
      });
      if (match) {
        if (variantInput) variantInput.value = match.id;
        if (priceEl) priceEl.textContent = match.price;
        if (installEl && match.installment) installEl.textContent = match.installment;
        syncButton(addBtn, match.available);
        syncButton(buyBtn, match.available);
      }
    }

    root.querySelectorAll("[data-f-option-value]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var group = btn.closest("[data-f-option]");
        group.querySelectorAll("[data-f-option-value]").forEach(function (b) { b.classList.remove("is-active"); });
        btn.classList.add("is-active");
        selected[group.getAttribute("data-f-option")] = btn.getAttribute("data-f-value");
        applySelection();
      });
    });

    applySelection();
  });

  // ---- Quick add (product/collection cards) -> AJAX add to cart ----
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-f-quick-add]");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = btn.getAttribute("data-f-quick-add");
    if (!variantId) return;
    var original = btn.textContent;
    btn.textContent = "Adding…";
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = "Added ✿";
        updateCartCount();
        setTimeout(function () { btn.textContent = original; }, 1600);
      })
      .catch(function () { btn.textContent = original; });
  });

  function updateCartCount() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-f-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }

  // ---- Newsletter form (customer/email signup via native Shopify contact form fallback) ----
  document.querySelectorAll("[data-f-newsletter]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      var input = form.querySelector("input[type='email']");
      if (!input || !input.value) { e.preventDefault(); }
    });
  });
})();
